import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Card from '../../layout/Card';
import ModuleHome from '../../layout/ModuleHome';
import { breadcrumbsPropTypes } from '../../common/resource/proptypes/CommonPropTypes';

export const SalesHome = ({ cards, breadcrumbs }) => (
  <ModuleHome
    title="Gestión de Ventas"
    text="Éste es el módulo de Gestión de Ventas."
    cards={cards}
    breadcrumbs={breadcrumbs}
  />
);

const mapStateToProps = ({ SalesUnit }) => ({
  cards: SalesUnit.UnitHome.get('cards'),
  breadcrumbs: SalesUnit.UnitHome.get('breadcrumbs'),
});

SalesHome.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)).isRequired,
};

export default connect(mapStateToProps)(SalesHome);
